module.exports = __webpack_public_path__ + "img/1530753645.d859f6ca.jpg";